var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartMeter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m510 75h-81.507l-45-75h-256.986l-45 75h-81.507v345h90v34.542l36.972 55.458h256.056l36.972-55.458v-34.542h90zm-366.507-45h223.015l27 45h-277.015zm246.507 415.458-23.028 34.542h-223.944l-23.028-34.542v-25.458h30v30h30v-30h30v30h30v-30h30v30h30v-30h30v30h30v-30h30zm90-55.458h-60-330-60v-285h33.507 382.985 33.508z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 285h360v-150h-360zm165-30h-45v-90h45zm30-90h45v90h-45zm135 90h-60v-90h60zm-300-90h60v90h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270 330h165v30h-165z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75 330h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135 330h30v30h-30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartMeter);
export default __webpack_public_path__ + "static/media/SmartMeter.dba0aef8.svg";
export { ForwardRef as ReactComponent };